import Header from '../components/Header';
import Hero from '../components/Hero';
import Footer from '../components/Footer';
import BenefitCard from '../components/BenefitCard';

const OurBenefits = () => {
  const benefits = [
    // Removed Shopping Discounts
    {
      icon: (
        <svg className="w-32 h-32" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* Person */}
          <circle cx="45" cy="35" r="12" stroke="#000" strokeWidth="4" fill="none"/>
          <path d="M30 80 C30 65 35 55 45 55 C55 55 60 65 60 80" stroke="#000" strokeWidth="4" fill="none"/>
          {/* Star */}
          <path d="M80 45 L83 53 L92 53 L85 59 L88 68 L80 62 L72 68 L75 59 L68 53 L77 53 Z" fill="#000"/>
          {/* Money bag */}
          <path d="M85 20 L95 20 L95 32 C95 37 90 40 85 40 C80 40 75 37 75 32 L75 20 L85 20" stroke="#000" strokeWidth="3" fill="none"/>
          <text x="85" y="32" fontSize="8" fontWeight="bold" textAnchor="middle" fill="#000">GBP</text>
        </svg>
      ),
      title: 'Refer a Friend'
    },
    {
      icon: (
        <svg className="w-32 h-32" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* Piggy bank */}
          <ellipse cx="60" cy="60" rx="35" ry="25" stroke="#000" strokeWidth="4" fill="none"/>
          <circle cx="70" cy="55" r="3" fill="#000"/>
          <path d="M95 55 L105 50" stroke="#000" strokeWidth="3"/>
          <path d="M40 75 L40 85 M50 75 L50 85 M70 75 L70 85 M80 75 L80 85" stroke="#000" strokeWidth="3"/>
          <path d="M50 45 L50 35" stroke="#000" strokeWidth="4"/>
          {/* Coins */}
          <circle cx="60" cy="25" r="8" stroke="#000" strokeWidth="3" fill="none"/>
          <text x="60" y="30" fontSize="10" fontWeight="bold" textAnchor="middle" fill="#000">$</text>
          <circle cx="75" cy="20" r="6" stroke="#000" strokeWidth="2" fill="none"/>
          <text x="75" y="24" fontSize="8" fontWeight="bold" textAnchor="middle" fill="#000">$</text>
        </svg>
      ),
      title: 'Pension Scheme'
    },
    {
      icon: (
        <svg className="w-32 h-32" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* Shield */}
          <path d="M60 20 L90 35 L90 60 C90 75 75 90 60 100 C45 90 30 75 30 60 L30 35 Z" fill="#000"/>
          {/* Checkmark */}
          <path d="M45 60 L55 70 L75 45" stroke="#2f4c74" strokeWidth="6" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: 'Funded DBS Check'
    },
    {
      icon: (
        <svg className="w-32 h-32" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* Chat bubble 1 */}
          <ellipse cx="45" cy="45" rx="25" ry="20" stroke="#000" strokeWidth="4" fill="none"/>
          <circle cx="35" cy="42" r="3" fill="#000"/>
          <circle cx="45" cy="42" r="3" fill="#000"/>
          <circle cx="55" cy="42" r="3" fill="#000"/>
          {/* Chat bubble 2 */}
          <ellipse cx="70" cy="70" rx="25" ry="20" stroke="#000" strokeWidth="4" fill="none"/>
          <circle cx="60" cy="67" r="3" fill="#000"/>
          <circle cx="70" cy="67" r="3" fill="#000"/>
          <circle cx="80" cy="67" r="3" fill="#000"/>
        </svg>
      ),
      title: 'Employee Assistance Programme'
    },
    // Removed Health Shield Cashback Plan
  ];

  return (
    <div className="OurBenefits">
      <Header />
      <div className="mt-32 sm:mt-36 lg:mt-32">
        {/* Hero Section */}
        <Hero
          image="https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&w=1920"
          heightClass="min-h-[50vh] sm:min-h-[55vh] md:min-h-[60vh] lg:min-h-[66vh]"
          position="center"
          overlay={true}
          contentClassName="absolute inset-x-0 bottom-0 z-10 flex justify-center px-4 sm:px-6 md:px-8 pb-6 sm:pb-8 md:pb-10"
        >
          <div className="w-full max-w-4xl bg-white bg-opacity-95 rounded-2xl shadow-lg py-6 sm:py-8 md:py-10 px-4 sm:px-6 md:px-8 text-center">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light text-[#2b3d57]">
              Our Benefits
            </h1>
            <p className="mt-2 sm:mt-3 text-sm sm:text-base md:text-lg text-[#2b3d57] opacity-80 max-w-2xl mx-auto">
              We value our team and offer competitive benefits to support your wellbeing and career growth
            </p>
          </div>
        </Hero>

      {/* Benefits Grid */}
      <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-10 lg:gap-12">
            {benefits.map((benefit, index) => (
              <BenefitCard
                key={index}
                icon={benefit.icon}
                title={benefit.title}
                crossed={benefit.crossed}
              />
            ))}
          </div>
        </div>
      </section>

        <Footer />
      </div>
    </div>
  );
};

export default OurBenefits;



